import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const BalanceResetIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={36}
      height={36}
      fill="none"
      {...props}
    >
      <rect width={36} height={36} fill={theme.palette.grey[200]} rx={18} />
      <path
        stroke={theme.palette.common.black}
        strokeLinecap="round"
        strokeWidth={1.25}
        d="M11.221 10.527V15.358c0 .043.035.078.078.078h4.83"
      />
      <path
        stroke={theme.palette.common.black}
        strokeLinecap="round"
        strokeWidth={1.25}
        d="M11.827 20.812A6.78 6.78 0 1 0 18 11.228a6.779 6.779 0 0 0-6.085 3.788"
      />
    </svg>
  );
};
